export default "__VITE_ASSET__e76ff252__"